import { ChangeDetectionStrategy, Component, input } from '@angular/core';

import { TranslatePipe } from '@core/i18n-legacy';
import type { Option, ScorecardsResult } from '@core/interview-results-types';

import { ScorecardsItemRowComponent } from './scorecards-item-row/scorecards-item-row.component';

@Component({
  selector: 'rt-interview-result-summary-scorecards-item',
  templateUrl: 'interview-result-summary-scorecards-item.component.html',
  styleUrls: ['./interview-result-summary-scorecards-item.component.less'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [ScorecardsItemRowComponent, TranslatePipe],
})
export class InterviewResultSummaryScorecardsItemComponent {
  public readonly scorecardsResult = input<ScorecardsResult>(undefined!);

  public trackByTitle(index: number, item: Option): string {
    return item.title;
  }
}
